import React, { useEffect, useState } from "react";
import Sidebar from "./sidebar/Sidebar";
import axios from "axios";
import api from "../api/axios";
function MyProfile() {
  //state
  const [sidebarToggle, setSidebarToggle] = useState(true);
  const [userdata, setUserdata] = useState([]);
  const [currentUser, setCurrentUser] = useState("");
  

  const fetchuserdata = async () => {
    const res = await api.get("/order");
    const currUser = localStorage.getItem("useremail");
    setCurrentUser(currUser);
    setUserdata(res.data);
  };

  useEffect(() => {
    fetchuserdata();
  }, []);

  const filtereddata = userdata.filter((user) => user.emaiid === currentUser);

  const uniquePayments = filtereddata.filter(
    (value, index, self) => index === self.findIndex((t) => t.id === value.id)
  );

  const groupedData = Object.values(
    uniquePayments.reduce((acc, curr) => {
      const email = (curr?.emaiid || "unknown").toLowerCase();

      if (!acc[email]) {
        acc[email] = {
          email: email,
          id: curr.id,
          firstName: curr?.firstName || "",
          lastName: curr?.lastName || "",
          phone: curr?.phone || "",
          address: curr?.streetAddress || "",
          city: curr?.city || "",
          state: curr?.state || "",
          pincode: curr?.postcade || "",
          payments: [],
        };
      }

      acc[email].payments.push(curr);
      return acc;
    }, {})
  );

  //sidebar toggle
  const toggleClick = () => {
    setSidebarToggle(!sidebarToggle);
  };

  return (
    <>
      {/* header section-1 */}
      <div className="font-[Poppins] flex ">
        {sidebarToggle ? <div className="w-[320px] nirav"></div> : null}
        <Sidebar toggleClick={toggleClick} sidebarToggle={sidebarToggle} />
        <div className="w-[100%] ">
          <div className=" 2xl:w-[90%] w-[95%] m-auto 2xl:mt-16 mt-10  xl:p-2 lg:p-10  p-2">
            <div className="sm:flex sm:justify-between sm:items-center">
              <h1 className="font-medium 2xl:text-2xl text-xl">
                My Profile
              </h1>
            </div>
            <div className="border mt-5 flex flex-col gap-16 justify-center items-center 2xl:rounded-[30px] rounded-[20px] px-10 py-8  bg-white shadow-sm">
              <div className="flex justify-center items-center gap-4 ">
                <i className="fa-solid fa-circle-user text-[50px]"></i>
                {groupedData.length >
                  0 ? (
                  <div>
                    <h4 className="font-semibold text-xl">
                      {groupedData[0].firstName || "-"}
                      {groupedData[0].lastName || "-"}
                    </h4>
                    <p className="text-xs text-[#757575]">
                      {groupedData[0].email || "-"}
                    </p>
                  </div>
                ) : "-"}
              </div>

              <div className="grid grid-cols-2 gap-56">
                <div className="leading-10">
                  <p>name</p>
                  <p>Email</p>
                  <p>Phone</p>
                  <p>Address</p>
                  <p>State</p>
                  <p>City</p>
                  <p>Pincode</p>
                </div>
                <div className="leading-10 text-[#757575]">
                  {groupedData.length >
                    0 ? (
                    <>
                      <p>
                        {groupedData[0].firstName || "-"}
                        {groupedData[0].lastName || "-"}
                      </p>
                      <p>{groupedData[0].email || "-"}</p>
                      <p>{groupedData[0].phone || "-"}</p>
                      <p>{groupedData[0].address || "-"}</p>
                      <p>{groupedData[0].state || "-"}</p>
                      <p>{groupedData[0].city || "-"}</p>
                      <p>{groupedData[0].pincode || "-"}</p>
                    </>
                  ) : "-"}
                </div>
              </div>

              {/* <div>
                <p className="text-[#C65B1D]">change password</p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MyProfile;
